import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UserCustomerDTO } from "src/app/data/schema/Billing/Customer/UserCustomerDTO";
import { environment } from "src/environments/environment";
import { CreditCardResponse } from "../../schema/Billing/Asaas/CreditCardResponse";
import { BillingProviderEnumDTO } from "../../schema/Billing/BillingProviderEnumDTO";
import { CreditCardCreateDTO } from "../../schema/Billing/Customer/CreditCardCreateDTO";
import { CreditCardDTO } from "../../schema/Billing/Customer/CreditCardDTO";
import { CustomerGatewaySettingDTO } from "../../schema/Billing/Customer/CustomerGatewaySettingDTO";
import { UserCustomerUpdateDTO } from "../../schema/Billing/Customer/UserCustomerUpdateDTO";
import { AsaasTokenizeModel } from "../../schema/Billing/Models/AsaasTokenizeModel";
import { AsaasAnonymousTokenizeModel } from "../../schema/Billing/Models/AsaasAnonymousTokenizeModel";

@Injectable({
    providedIn: "root"
})
export class ApiBillingCustomerService {
    private relativePath: string;

    constructor(private http: HttpClient) {
        this.relativePath = `${environment.billing.url}/api/v1/UserCustomers`;
    }

    public get(id: string): Observable<UserCustomerDTO> {
        return this.http.get<UserCustomerDTO>(`${this.relativePath}/${id}`);
    }

    public update(id: string, dto: UserCustomerUpdateDTO): Observable<UserCustomerDTO> {
        return this.http.put<UserCustomerDTO>(`${this.relativePath}/${id}`, dto);
    }

    public getGatewaySetting(
        id: string,
        affiliateId: string,
        provider: BillingProviderEnumDTO
    ): Observable<CustomerGatewaySettingDTO> {
        return this.http.get<CustomerGatewaySettingDTO>(
            `${this.relativePath}/${id}/${provider}?affiliateId=${affiliateId}`
        );
    }

    public insertCreditCard(
        id: string,
        billingProvider: BillingProviderEnumDTO,
        affiliateId: string,
        creditCard: CreditCardCreateDTO
    ): Observable<CustomerGatewaySettingDTO> {
        return this.http.post<CustomerGatewaySettingDTO>(
            `${this.relativePath}/${id}/${billingProvider}/credit-card?affiliateId=${affiliateId}`,
            creditCard
        );
    }

    public tokenizeAsaasCreditCard(id: string, model: AsaasTokenizeModel): Observable<CreditCardResponse> {
        return this.http.post<CreditCardResponse>(`${this.relativePath}/${id}/Asaas/credit-card/tokenize`, model);
    }

    public tokenizeAsaasCreditCardAnonymous(model: AsaasAnonymousTokenizeModel): Observable<CreditCardResponse> {
        return this.http.post<CreditCardResponse>(`${this.relativePath}/Asaas/credit-card/tokenize`, model);
    }

    public setAsDefault(
        id: string,
        billingProvider: BillingProviderEnumDTO,
        externalId: string,
        affiliateId: string
    ): Observable<CustomerGatewaySettingDTO> {
        return this.http.patch<CustomerGatewaySettingDTO>(
            `${this.relativePath}/${id}/${billingProvider}/credit-card/${externalId}/setAsDefault?affiliateId=${affiliateId}`,
            null
        );
    }

    public removeCreditCard(
        id: string,
        billingProvider: BillingProviderEnumDTO,
        externalId: string,
        affiliateId: string
    ): Observable<CustomerGatewaySettingDTO> {
        return this.http.delete<CustomerGatewaySettingDTO>(
            `${this.relativePath}/${id}/${billingProvider}/credit-card/${externalId}?affiliateId=${affiliateId}`
        );
    }

    public updateCreditCard(
        id: string,
        billingProvider: BillingProviderEnumDTO,
        affiliateId: string,
        creditCard: CreditCardDTO
    ): Observable<CustomerGatewaySettingDTO> {
        return this.http.patch<CustomerGatewaySettingDTO>(
            `${this.relativePath}/${id}/${billingProvider}/credit-card/${creditCard.externalId}?affiliateId=${affiliateId}`,
            creditCard
        );
    }
}
